/**
 * Normalize stored task result for dashboard display.
 * Supports full gem (POST /rocks/identify), legacy v2 unified, wrapped poll payload.
 *
 * @returns {{ kind: 'gem'|'unified'|'empty', data: object|null }}
 */
export function normalizeIdentifyTaskResult(task) {
  const raw = task?.stored_result ?? task?.result_data ?? null;
  if (!raw || typeof raw !== "object") {
    return { kind: "empty", data: null };
  }

  if (raw.result && typeof raw.result === "object" && !raw.uid && !raw.latin_name && !raw.preferred_name) {
    return normalizeIdentifyTaskResult({ stored_result: raw.result });
  }

  if (isGemPayload(raw)) {
    return { kind: "gem", data: raw };
  }

  if (isEstimatePricePayload(raw)) {
    return { kind: "price", data: raw };
  }

  if (isUnifiedPayload(raw)) {
    return { kind: "unified", data: raw };
  }

  return { kind: "unified", data: raw };
}

function isGemPayload(obj) {
  if (!obj || typeof obj !== "object") return false;
  const hasIdentity = Boolean(obj.uid || obj.latin_name || obj.preferred_name);
  const hasRichFields =
    Array.isArray(obj.content) ||
    Array.isArray(obj.tags) ||
    Array.isArray(obj.images) ||
    obj.main_image_url;
  return hasIdentity && hasRichFields;
}

function isEstimatePricePayload(obj) {
  return (
    obj &&
    typeof obj === "object" &&
    ("valuation_ui" in obj || ("from_price" in obj && "to_price" in obj))
  );
}

function isUnifiedPayload(obj) {
  return (
    obj &&
    typeof obj === "object" &&
    ("is_rock" in obj || "photo_list" in obj || "identification_id" in obj)
  );
}

export function taskResultDisplayName(result) {
  if (!result?.data) return "—";
  const d = result.data;
  return d.preferred_name || d.latin_name || d.common_name || d.name || "—";
}
